import { ACTION } from './province_actions';

const initialState = {
  provinces: {},
  orderedIds: [],
  loading: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        loading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        provinces: action.payload.reduce((provinces, province) => ({...provinces, [province.id]: province}), {}),
        orderedIds: action.payload.map(province => province.id),
        loading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/provinces/province_reducers.js